export default __webpack_public_path__ + "static/media/LA-1.e3b693ca.JPG";